import { useTranslations } from "next-intl";
import VideoPlayer from "src/components/player/VideoPlayer";

const HowDoesShemsiWork = () => {
  const t = useTranslations("UseYourShemsi");

  return (
    <section className="flex flex-col items-center gap-2.5">
      <h2 className="text-2xl font-bold lg:text-3xl">
        {t("how_does_shemsi_underwear_work")}
      </h2>
      <VideoPlayer
        videoTrackingName="Use Your Shemsi"
        videoId="TN5Bzllrq3g"
        cover="/images/how-does-shemsi-work.png"
        alt={t("how_does_shemsi_underwear_work")}
        className="aspect-h-8 aspect-w-16 lg:aspect-h-9"
      />
    </section>
  );
};

export default HowDoesShemsiWork;
